export default __webpack_public_path__ + "static/media/updated-ISKO.ff55849a.pdf";